import { motion } from "framer-motion";
import { Crown, Filter, Handshake } from "lucide-react";

const secrets = [
  {
    icon: Crown,
    number: "01",
    title: "Mensaje y Oferta de Autoridad",
    subtitle: "El Filtro de Alto Valor",
    paragraphs: [
      'La mayoría de profesionales consolidados cometen el error de comunicar "servicios genéricos" en lugar de "transformaciones".',
      '"Cobrar barato" cuando tenés años de trayectoria no te hace competitivo, hace que el cliente de alto valor desconfíe.',
      "Tu mensaje debe actuar como un filtro automático: debe atraer a quienes valoran el prestigio y repeler a los que buscan precio.",
    ],
  },
  {
    icon: Filter,
    number: "02",
    title: "El Embudo de Conversión Oculto",
    subtitle: "Soberanía de Tiempo para el CEO",
    paragraphs: [
      "Dejá de pensar que hay que ser influencer o estar bailando en redes.",
      '"Tener likes no paga los sueldos." Las redes sociales son solo la vidriera; el verdadero negocio ocurre en tu Embudo Oculto.',
      "Necesitas un sistema donde tu contenido atraiga prospectos calificados y un equipo (o sistema automatizado) genere conversaciones en privado. Tu trabajo como CEO no es crear contenido todo el día, es liderar mientras el sistema filtra a los curiosos.",
    ],
  },
  {
    icon: Handshake,
    number: "03",
    title: "El Cierre Consultivo",
    subtitle: "Posicionarte como el Premio",
    paragraphs: [
      "Las marcas referentes no persiguen clientes, los atraen. Si en tus reuniones de venta te regatean el precio, tu marca está fallando antes de la llamada.",
      'Una marca con prestigio no tiene "llamadas de venta", tiene "Pre-diagnósticos". El cliente debe sentir que vos lo estás evaluando a él para ver si califica para trabajar con tu empresa.',
      "Cuando cambias la dinámica de poder, la fricción del precio desaparece. Pero además le aportás valor real. Dejá de querer vender, enfocate en ser valioso.",
    ],
  },
];

const ThreeSecrets = () => {
  return (
    <section id="secretos" className="py-24 md:py-32 relative overflow-hidden bg-foreground text-background">
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-900 to-black" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 rounded-full blur-3xl" />

      <div className="container px-4 relative z-10">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-4xl mx-auto mb-20"
        >
          <span className="text-sm font-semibold tracking-widest uppercase mb-4 block text-rose-light">
            Los 3 Secretos del Sistema
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Para Marcas Personales que Quieren{" "}
            <span className="text-gradient-gold">Vender</span>
          </h2>
        </motion.div>

        {/* Secrets */}
        <div className="max-w-5xl mx-auto space-y-12">
          {secrets.map((secret, index) => (
            <motion.div
              key={secret.number}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: index * 0.1 }}
              className="bg-neutral-900/60 backdrop-blur-sm rounded-2xl p-8 md:p-12 border border-neutral-800 hover:border-primary/40 transition-all duration-500"
            >
              <div className="flex items-start gap-6">
                {/* Number + Icon */}
                <div className="hidden md:flex flex-col items-center gap-3">
                  <span className="text-5xl font-display font-bold text-primary/30">
                    {secret.number}
                  </span>
                  <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center">
                    <secret.icon className="w-7 h-7 text-primary-foreground" />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2 md:hidden">
                    <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-primary/80 flex items-center justify-center">
                      <secret.icon className="w-5 h-5 text-primary-foreground" />
                    </div>
                    <span className="text-2xl font-display font-bold text-primary/40">
                      {secret.number}
                    </span>
                  </div>
                  <h3 className="font-display text-2xl md:text-3xl font-bold text-white mb-1">
                    {secret.title}
                  </h3>
                  <p className="text-rose-light font-medium text-lg mb-6">
                    {secret.subtitle}
                  </p>
                  <div className="space-y-4">
                    {secret.paragraphs.map((p, i) => (
                      <p
                        key={i}
                        className="text-neutral-300 leading-relaxed text-base md:text-lg"
                      >
                        {p}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreeSecrets;
